import React from 'react'
import logo from './../../assets/images/logo.PNG'
import { SideBarContext } from '../../store/sidebar/context';
import { Link } from 'react-router-dom';
import { useShared } from "../../hooks/useShared";
export default function SidebarHeader() {
    //const { pushSideBar } = React.useContext(SideBarContext);
    const { pushSideBar } = useShared();
    return (
        <div className="sidebar-header flex items-center  py-1 px-4 bg-main-color">
            <div className="inline-flex">
                <Link to={'/db/dashboard'} className="inline-flex flex-row items-center">
                  
                    <img
                        src={logo}
                        alt="Logo"
                        className="h-10 w-10 bg-gray-200 border rounded-full"
                        />
                    <span className={` ${!pushSideBar ? 'opacity-1 transform transition-full duration-500 ease-in truncate sidbarTitle ' : 'opacity-0 '} `}>ACMEG Database</span>
                </Link>
            </div>
        </div>
    )
}
